module.exports = __webpack_public_path__ + "img/image3.62f850d7.png";